'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'person-breastfeeding';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e53a';
var svgPathData = 'M176.1 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM103.4 273.9c20.8-31.2 55.7-49.9 93.2-49.9l68.1 0c30.9 0 60.5 12.8 81.6 35.3l55.5 59.1c14.6 15.6 14.4 39.9-.4 55.2l-76.8 79.2c-6.2 6.3-6 16.5 .3 22.6s16.5 6 22.6-.3l76.8-79.2c26.8-27.6 27.1-71.4 .8-99.4l-55.5-59.1c-27.2-29-65.2-45.4-105-45.4l-68.1 0c-48.1 0-93.1 24.1-119.8 64.1L23.1 336.7C-1.4 373.4 12.7 423.4 52.8 442l148.6 68.6c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L66.3 412.9c-22.3-10.3-30.1-38.1-16.5-58.5l53.7-80.5zM192.1 320c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.4c0 6 1.7 11.9 4.9 17 26.3 42.1 72.4 67.6 122 67.6l1.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-1.1 0c-38.6 0-74.4-19.9-94.9-52.6l0-43.4zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonBreastfeeding = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;